var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"title":"Google Sheet Sync","icon":"mdi-google-spreadsheet","stateendpoint":"googleSheet.googleSheets","show-add-button":false,"actions":_vm.actions,"show-default-action-buttons":false,"action-buttons":_vm.actionButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }